// Shared labels and helpers for the partner commission page (PRO-12830).

export const CATEGORY_LABELS = {
  taxes: 'Taxes/VAT',
  medications_materials: 'Medications & materials',
  prostheses_implants: 'Prostheses & implants',
  non_medical_services: 'Non-medical services',
  take_home_products: 'Take-home products',
  local_tax: 'Local/tourist tax',
  transfer_hotel: 'Hotel & transfer (column for the partner)',
};

export const PROCEDURE_TYPES = [
  { value: 'operation', label: 'Operation' },
  { value: 'diagnostic', label: 'Diagnostic' },
];

export const COMMISSION_TYPES = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'fixed', label: 'Fixed' },
  { value: 'zero', label: 'Zero' },
];

// Matches the agencies service: up to 8 integer digits, up to 2 decimals.
export const DECIMAL_RE = /^\d{1,8}(\.\d{1,2})?$/;

export const categoryLabel = (category) => CATEGORY_LABELS[category] || category;

export const procedureTypeLabel = (type) => {
  const found = PROCEDURE_TYPES.find((t) => t.value === type);
  return found ? found.label : type;
};

export const commissionTypeLabel = (type) => {
  const found = COMMISSION_TYPES.find((t) => t.value === type);
  return found ? found.label : type;
};

// Server violation codes → human text. Unknown codes are shown as-is.
const VIOLATION_MESSAGES = {
  required: 'This field is required',
  invalid: 'Invalid value',
  must_be_positive: 'Must be greater than 0',
  percentage_above_100: 'Must not exceed 100%',
  must_be_zero_for_zero_type: 'Must be 0 for the "zero" type',
  before_valid_from: 'Must not be earlier than "valid from"',
  must_be_percentage_0_100: 'Must be a percentage greater than 0 and not above 100',
  must_be_0_or_1: 'Invalid value',
  must_be_json_list: 'Invalid list',
  unknown_category: 'Unknown category',
};

// Whole-request (non-field) errors.
export const TERMS_NO_FIELDS_MESSAGE = 'Nothing to save';

export const violationMessage = (code) => VIOLATION_MESSAGES[code] || code;
